'use client';

import React, { useImperativeHandle } from 'react';
import Avatar from '@mui/material/Avatar';
import {
    MessageProps,
    UserMessageAnimationHandle,
} from './chat-demo-type-defs';
import { useTheme } from '@mui/material/styles';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import gsap from 'gsap';

const UserMessage: React.ForwardRefRenderFunction<
    UserMessageAnimationHandle,
    { message: MessageProps }
> = ({ message }, ref) => {
    const theme = useTheme();

    const { generateImageConfig, content, sender } = message;
    const promptConfigs = generateImageConfig
        ? `${generateImageConfig.width}x${generateImageConfig.height}, ${generateImageConfig.steps}, ${generateImageConfig.cfgScale}, ${generateImageConfig.imageCount}`
        : '512x512, 50, 7, 1';

    const rootRef = React.useRef<HTMLDivElement>(null);

    const getAnimation = () => {
        const tl = gsap.timeline();
        tl.fromTo(
            rootRef.current,
            { opacity: 0, yPercent: 30 },
            { opacity: 1, yPercent: 0, duration: 0.5 },
        );
        return tl;
    };

    useImperativeHandle(ref, () => ({
        getAnimation,
    }));

    return (
        <div
            ref={rootRef}
            className="tablet:px-[16px] flex w-full flex-row px-[8px]"
        >
            <div className="flex justify-center">
                {/*头像*/}
                <Avatar
                    sx={{
                        width: 30,
                        height: 30,
                        [theme.breakpoints.up(735)]: {
                            width: 40,
                            height: 40,
                        },
                    }}
                    alt="kevin"
                    src={getStaticAssetUrl('/simulaix/kevin-avatar.png')}
                />
            </div>

            {/*消息*/}
            <div className="tablet:ml-[12px] ml-[8px] flex flex-col gap-[4px]">
                {/*用户名 + 时间戳*/}
                <div className="j-l2 font-medium text-[#06060A]">{sender}</div>
                {/*消息内容（prompt）*/}
                <div className="j-t4 text-[#06060A]">{`${content}`}</div>
                {/*bs*/}
                <div className="j-t4 text-[#878789]">
                    {`(Bs : ${promptConfigs})`}
                </div>
            </div>
        </div>
    );
};

export default React.memo(React.forwardRef(UserMessage));
